export const phoneRegExp: RegExp = /\d.*-\d.{4,15}$/ig
export const postalCodeRegExp: RegExp = /[-a-zA-Z0-9@:{}%.-_\+~#=].{3,}/ig
export const linkRegExp: RegExp = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/ig
